/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import Slider from 'react-slick';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import ReactPlayer from 'react-player';
// import StepItem from "../../components/StepItem";

class Video extends Component {
  state = {
    select: 0,
    mouseOver: false,
    mouseSlider: false,
    slideIndex: 0,
    videoList: [
      { title: '오프닝', url: '' },
      { title: '엔딩', url: '' },
      { title: 'pv', url: '' },
    ],
    playUrl: '',
  };
  _isMounted = false;
  componentDidMount = () => {
    const { opening, ending, pv } = this.props.childProps;
    this._isMounted = true;
    // console.log(opening);
    if (this._isMounted) {
      this.setState({
        videoList: [
          { title: '오프닝', url: opening },
          { title: '엔딩', url: ending },
          { title: 'PV', url: pv },
        ],
      });
    }
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.opening !== nextProps.childProps.opening;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (this.props.childProps.opening !== nextProps.childProps.opening) {
      this.setState({
        videoList: [
          { title: '오프닝', url: nextProps.childProps.opening },
          { title: '엔딩', url: nextProps.childProps.ending },
          { title: 'PV', url: nextProps.childProps.pv },
        ],
      });
    }
  };
  _play = (url, index) => {
    // console.log(url, index);
    if (url) {
      this.setState({
        playUrl: url,
        select: index,
      });
    }
  };
  _renderItem = () => {
    const { videoList, select } = this.state;
    const list = videoList.map((item, index) => {
      return (
        <div
          className={index === select ? 'videoBox_on' : 'videoBox'}
          key={index}
          onClick={() => this._play(item.url, index)}
        >
          {item.title}
        </div>
      );
    });

    return list;
    // return (
    //   <>
    //     <div>Opening</div>
    //     <div>Ending</div>
    //     <div>PV</div>
    //   </>
    // );
  };

  _onSelect = (key) => {
    //console.log(key)
    // this.slider.slickGoTo(key);
    // this.setState({
    //   select: key,
    // });
  };
  _onToggleMouse = () => {
    const { mouseOver } = this.state;
    this.setState({
      mouseOver: !mouseOver,
    });
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };
  _toggleSlider = () => {
    const { mouseSlider } = this.state;
    this.setState({
      mouseSlider: !mouseSlider,
    });
  };

  render() {
    const { stillList, select, mouseOver, mouseSlider, videoList, playUrl } =
      this.state;
    const { opening, ending, pv } = this.props.childProps;
    var settings = {
      dots: false,
      dotsClass: 'slick-dots slick-thumb',
      infinite: true,
      //speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      //speed: 3000,
      pauseOnFocus: true,

      //className: 'view_max_img',
      useCSS: true,
      adaptiveHeight: true,
      //fade: true,
      beforeChange: (current, next) => this.setState({ select: next }),
    };

    return (
      <Fragment>
        <div className="detil_group3">
          <h1>
            영상<span></span>
            <div>
              <strong>
                <em></em>
              </strong>
            </div>
          </h1>
          <div className="seutilkeos_group">
            <div className="seutilkeos_tab">
              <div
                className="div_ul"
                onMouseEnter={this._onToggleMouse}
                onMouseLeave={this._onToggleMouse}
              >
                <ScrollMenu
                  data={this._renderItem()}
                  //   arrowLeft={
                  //     mouseOver ? (
                  //       <a href="#" className="pre_btn on">
                  //         이전
                  //       </a>
                  //     ) : null
                  //   }
                  //   arrowRight={
                  //     mouseOver ? (
                  //       <a href="#" className="next_btn on">
                  //         다음
                  //       </a>
                  //     ) : null
                  //   }
                  //selected={selected}
                  //onSelect={this.onSelect}
                  alignCenter={false}
                  dragging={false}
                  onSelect={this._onSelect}
                />
              </div>
            </div>

            <div
              className="seutilkeos_img"
              onMouseEnter={this._toggleSlider}
              onMouseLeave={this._toggleSlider}
            >
              {opening === '' && ending === '' && pv === '' ? (
                <div style={{ color: '#fff', fontSize: 20, marginTop: 30 }}>
                  업데이트를 준비중입니다.
                </div>
              ) : (
                <ReactPlayer
                  ref={(ref) => (this.video = ref)}
                  url={playUrl ? playUrl : opening}
                  playing={false}
                  controls
                  volume={0.5}
                  width="100%"
                  height="100%"
                />
              )}

              {/* {mouseSlider ? (
                  <Fragment>
                    <a
                      style={{ cursor: 'pointer' }}
                      className="pre_btn"
                      onClick={this._onPrev}
                    >
                      이전
                    </a>
                    <a
                      style={{ cursor: 'pointer' }}
                      className="next_btn"
                      onClick={this._onNext}
                    >
                      다음
                    </a>
                  </Fragment>
                ) : null}

                <Slider ref={(ref) => (this.slider = ref)} {...settings}>
                  {stillList ? this._renderSliderItem() : null}
                </Slider> */}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Video));
